export const resendLinkPath = '/resend-link';